import React from 'react';

function currencyValue(amount, currency) {
  const numeric = Number(amount || 0);
  return `${currency || 'GMD'} ${numeric.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

function Row({ label, value }) {
  return (
    <div className='QuoteResultRow'>
      <span>{label}</span>
      <strong>{value ?? '-'}</strong>
    </div>
  );
}

function QuoteResultModal({ data, onClose }) {
  if (!data) {
    return null;
  }

  const hasError = Boolean(data.error);
  const currency = data.currency || 'GMD';
  const pa = data.paRisks || null;

  // Resolve policy period from any form type
  let policyPeriod = '-';
  if (pa && pa.startDate && pa.endDate) {
    policyPeriod = `${new Date(pa.startDate).toLocaleDateString()} - ${new Date(pa.endDate).toLocaleDateString()}`;
  } else if (data.vehicles && data.vehicles[0] && data.vehicles[0].startDate && data.vehicles[0].endDate) {
    policyPeriod = `${new Date(data.vehicles[0].startDate).toLocaleDateString()} - ${new Date(data.vehicles[0].endDate).toLocaleDateString()}`;
  } else if (data.travel && data.travel.departureDate && data.travel.returnDate) {
    policyPeriod = `${new Date(data.travel.departureDate).toLocaleDateString()} - ${new Date(data.travel.returnDate).toLocaleDateString()}`;
  } else if (data.startDate && data.endDate) {
    policyPeriod = `${new Date(data.startDate).toLocaleDateString()} - ${new Date(data.endDate).toLocaleDateString()}`;
  }

  return (
    <div className='QuoteModalOverlay' role='dialog' aria-modal='true'>
      <div className='QuoteModal'>
        <div className='QuoteModalHeader'>
          <h3>{hasError ? 'Request Error' : 'Estimated Quote'}</h3>
          <button type='button' onClick={onClose}>Close</button>
        </div>

        {hasError ? (
          <p className='QuoteErrorText'>{data.error}</p>
        ) : (
          <div className='QuoteResultBody'>
            <div className='QuoteResultGrid'>
              <Row label='Customer' value={data.fullName} />
              <Row label='Product' value={data.product} />
              <Row label='Phone' value={data.phone} />
              <Row label='Currency' value={currency} />
              <Row label='Total Premium' value={currencyValue(data.TotalPremium, currency)} />
              <Row label='VAT Premium' value={currencyValue(data.TotalVatPremium, currency)} />
              {data.TotalSumInsured > 0 && <Row label='Total Sum Insured' value={currencyValue(data.TotalSumInsured, currency)} />}
              <Row label='Policy Period' value={policyPeriod} />
            </div>

            {pa && (
              <div className='QuoteResultSection'>
                <h4>Personal Accident Breakdown</h4>
                <div className='QuoteResultGrid'>
                  <Row label='Medical Expense Benefit' value={currencyValue(pa.medicalExpenseBenefit, currency)} />
                  <Row label='Medical Benefit Rate' value={`${pa.medicalExpenseBenefitRate ?? 0}%`} />
                  <Row label='Permanent Disability Benefit' value={currencyValue(pa.permanentDisabilityBenefit, currency)} />
                  <Row label='Permanent Disability Rate' value={`${pa.permanentDisabilityBenefitRate ?? 0}%`} />
                  <Row label='Temporary Disability Benefit' value={currencyValue(pa.temporalDisabilityBenefit, currency)} />
                  <Row label='Temporary Disability Rate' value={`${pa.temporalDisabilityBenefitRate ?? 0}%`} />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default QuoteResultModal;
